import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MyHttpClientFactory, environment } from '@ups/xplat/core';
import { parseData } from '@ups/xplat/utils';
import { ItemDTO, ItemListDTO } from '../models';

const ITEM = '/api/Item';
const ITEM_LIST = '/api/Item/list';
const ITEM_BY_ID = (itemId) => `/api/Item/${itemId}`;
const ITEM_NOT_IN_TEMPLATE = (inventoryTemplateId) =>
  `/api/Item/notInTemplate/${inventoryTemplateId}`;
const ITEM_NOT_IN_COUNT = (inventoryCountId) =>
  `/api/Item/notInCount/${inventoryCountId}`;
@Injectable({
  providedIn: 'root',
})
export class ItemService {
  private http: HttpClient;

  constructor(httpClientFactory: MyHttpClientFactory) {
    this.http = httpClientFactory.createHttpClient(
      environment.urls.toolTrackerAPI,
      true
    );
  }

  public fetchItems(
    odataString: string,
    searchString: string
  ): Observable<ItemDTO[]> {
    let url = ITEM;
    url += '?$format=json&$count=true';
    url += searchString ? '&searchString=' + searchString : '';
    url += odataString ? '&' + odataString : '';
    return this.http.get<ItemDTO[]>(url).pipe(map(parseData));
  }

  public getItemsList(): Observable<ItemListDTO[]> {
    const url = ITEM_LIST;
    return this.http.get<ItemListDTO[]>(url).pipe(map(parseData));
  }

  public getItemById(itemId): Observable<ItemDTO> {
    const url = ITEM_BY_ID(itemId);
    return this.http.get<ItemDTO>(url).pipe(map(parseData));
  }

  public updateItem(item: ItemDTO): Observable<ItemDTO> {
    const url = ITEM_BY_ID(item.itemId);
    return this.http.put<ItemDTO>(url, item).pipe(map(parseData));
  }

  public createItem(item: ItemDTO): Observable<ItemDTO> {
    return this.http.post<ItemDTO>(ITEM, item).pipe(map(parseData));
  }

  public getItemsNotInTemplate(inventoryTemplateId): Observable<ItemDTO[]> {
    const url = ITEM_NOT_IN_TEMPLATE(inventoryTemplateId);
    return this.http.get<ItemDTO[]>(url).pipe(map(parseData));
  }

  public getItemsNotInCount(inventoryCountId): Observable<ItemDTO[]> {
    const url = ITEM_NOT_IN_COUNT(inventoryCountId);
    return this.http.get<ItemDTO[]>(url).pipe(map(parseData));
  }
}
